import React from 'react';
import {useDispatch} from 'react-redux';
import {getSharingDetailsPopup} from "../../../../../../../../../../../../../../../../../actions/sharingDetailsActions";
import Button from '../../../../../../../../../../../../../../../../components/button';

function DeleteContactButton ({contactId, contactName, contactEmail, contactType, title, disabled}) {

	const dispatch = useDispatch();

    const deleteContactHandler = (e) => {
	    e.stopPropagation();
        dispatch(getSharingDetailsPopup([true, 'delete_contact', {
	        "id": e.currentTarget.dataset.contactId,
	        "email": e.currentTarget.dataset.contactEmail,
	        "type": e.currentTarget.dataset.contactType
        }]))
    };

    return (
	    <Button
		    className="btn-link"
		    title={title || ''}
		    data-contact-id={contactId}
		    data-contact-email={contactEmail}
		    data-contact-type={contactType}
		    onClick={ deleteContactHandler }
		    disabled={disabled}
	    >
		    <div className="more-option-item__picto">
			    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
				    <path
					    fill="currentColor"
					    d="M 5.333 24 C 4.6 24 3.971 23.739 3.449 23.217 C 2.928 22.695 2.666 22.067 2.666 21.334 L 2.666 4 L 1.333 4 L 1.333 1.333 L 8 1.333 L 8 0 L 16 0 L 16 1.333 L 22.667 1.333 L 22.667 4 L 21.333 4 L 21.333 21.334 C 21.333 22.067 21.072 22.695 20.551 23.217 C 20.027 23.739 19.4 24 18.667 24 L 5.333 24 Z M 18.667 4 L 5.333 4 L 5.333 21.334 L 18.667 21.334 L 18.667 4 Z M 8 18.667 L 10.667 18.667 L 10.667 6.666 L 8 6.666 L 8 18.667 Z M 13.334 18.667 L 16 18.667 L 16 6.666 L 13.334 6.666 L 13.334 18.667 Z M 5.333 4 L 5.333 21.334 L 5.333 4 Z"
				    />
			    </svg>
		    </div>
		    <div className="more-option-item__text">
			    <span>{title}</span>
		    </div>
	    </Button>
    );
}

export default DeleteContactButton;
